import {AxiosResponse} from "axios";
import api from "../api";

export class AccessService {
    public checkAccesses (request: any): Promise<AxiosResponse<any>> {
        return api.post(`/security/check_accesses`, request);
    }
}